import React, { useEffect, useState } from "react";
import { Route, Routes, Navigate, useNavigate, useLocation } from "react-router-dom";
import ChannelTopic from "./create/Topic";
import ChannelAge from "./create/Agerating";
import ChanneCertification from "./create/Certification";
import ChannelSuccess from "./create/Success";
import CreateChannelContextLayout from "./CreateChannelContextLayout";

import { useNavigationBar } from "../../context/NavigationContext";

import Onboarding from "../onboarding";
import ProtectedDashboardRoutes from "../dashboard/ProtectedDashboardRoute";
import { UserRole, useAuth } from "../../context/AuthContext";
import { ChannelState } from "../../models/SKChannel";
import MyChannelHistory from "./create/MyChannelHistory";
import ChannelView from "./create/ChannelView";
import ModalLayout from "./ModalLayout";
import CreateChannelProvider from "../../context/CreateChannelContext";
import ChannelEditView from "./create/ChannelEditView";
import EditChannelProvider from "../../context/EditChannelContext";
import EditChannelContextLayout from "./EditChannelContextLayout";
import path from "path";

const Channel = () => {
  const context = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const { backgroundLocation } = useNavigationBar();
  const oldLocation = backgroundLocation?.pathname.includes("dashboard/channels") ? backgroundLocation : location;

  useEffect(() => {
    if (context && context.myChannel) {
      if (context.myChannel.status === ChannelState.DRAFT) {
        return navigate("./onboarding");
      }
    }
  }, [context]);

  // return (
  //   <>
  //     {/* <NavBarProvider> */}
  //     {/* <CreateChannelContextLayout> */}
  //     <Routes location={oldLocation}>
  //       <Route element={<CreateChannelContextLayout />}>
  //         <Route path="/" element={<ChannelView />} />
  //         {/* //element={<Navigate replace to={context?.myChannel ? "./onboard" : "./onboarding"} />} /> */}
  //         {/* <Route path="/onboard/*" element={<OnboardingEmpty />} /> */}
  //         <Route path="/onboard/*" element={<ChannelView />} />

  //         <Route path="/onboarding/*" element={<Onboarding />} />
  //         {/* <Route path="/description" element={<ChannelDescription />} /> */}
  //         {/* <Route path="/photos" element={<ChannelPhotos />} /> */}
  //         {/* <Route path="/dashboard/*" element={<Dashboard />} /> */}
  //         {/* <Route path="/details" element={<ChannelDetails />} /> */}
  //         <Route path="/topic" element={<ChannelTopic />} />
  //         <Route path="/age" element={<ChannelAge />} />
  //         <Route path="/certification" element={<ChanneCertification />} />
  //         {/* <Route path="/preview" element={<ChannelPreview />} /> */}
  //         <Route path="/history" element={<MyChannelHistory />} />
  //         <Route path="/success" element={<ChannelSuccess />} />
  //       </Route>

  //       <Route element={<CreateChannelContextLayout isEdit={true} />}>
  //         <Route path="/edit-channel" element={<ChannelView />} />

  //         <Route path="/edit-topic" element={<ChannelTopic />} />
  //         <Route path="/edit-age" element={<ChannelAge />} />
  //         <Route path="/edit-certification" element={<ChanneCertification />} />
  //       </Route>

  //       {/* <Route element={<ProtectedDashboardRoutes allowedRoles={[UserRole.CreatorAdmin, UserRole.Operator, UserRole.BrandAdmin]} />}></Route> */}
  //     </Routes>
  //     {backgroundLocation && (
  //       <Routes>
  //         <Route element={<ModalLayout />}>
  //           <Route element={<CreateChannelContextLayout />}>
  //             <Route path="/topic" element={<ChannelTopic />} />
  //             <Route path="/age" element={<ChannelAge />} />
  //             <Route path="/certification" element={<ChanneCertification />} />

  //             <Route path="/history" element={<MyChannelHistory />} />
  //             <Route path="/success" element={<ChannelSuccess />} />
  //           </Route>
  //           <Route element={<CreateChannelContextLayout isEdit={true} />}>
  //             <Route path="/edit-channel" element={<ChannelTopic />} />
  //             <Route path="/edit-topic" element={<ChannelTopic />} />
  //             <Route path="/edit-age" element={<ChannelAge />} />
  //             <Route path="/edit-certification" element={<ChanneCertification />} />
  //           </Route>
  //         </Route>
  //       </Routes>
  //     )}
  //   </>
  // );

  return (
    // All the routes soulld for CReatign a channel contained in CreatChannleProvider so all can have same data
    // but lay should be different for some of the route to present modally
    // Curently we are using CreateChannelContextLayout to wrap the COntext and provide the data to all the routes
    //this casee is haivng issue as the if(backGroundLocation) then those routes are having diffent context for the same data
    // so every route should be wrapped in CreateChannelProvider be it modal or not
    // so we can have same data for all the routes
    //and we can have different layout for modal and non modal routes

    <CreateChannelProvider>
      <Routes location={oldLocation}>
        <Route element={<CreateChannelContextLayout />}>
          <Route path="/" element={<ChannelView isModal={true} />} />
          <Route path="/view" element={<ChannelView isModal={true} />} />
          <Route path="/editChannel/*" element={<EditChannel />} />
          <Route path="/topic" element={<ChannelTopic />} />
          <Route path="/age" element={<ChannelAge />} />
          <Route path="/certification" element={<ChanneCertification />} />
          <Route path="/history" element={<MyChannelHistory />} />
          <Route path="/success" element={<ChannelSuccess />} />
          <Route path="/onboard/*" element={<ChannelView />} />
          <Route path="/onboarding/*" element={<Onboarding />} />

          {/* <Route path="/topic" element={<ChannelTopic />} />
          <Route path="/age" element={<ChannelAge />} />
          <Route path="/certification" element={<ChanneCertification />} />
          <Route path="/history" element={<MyChannelHistory />} />
          <Route path="/success" element={<ChannelSuccess />} /> */}
        </Route>

        {/* <Route element={<ProtectedDashboardRoutes allowedRoles={[UserRole.CreatorAdmin, UserRole.Operator, UserRole.BrandAdmin]} />}></Route> */}
      </Routes>
      {backgroundLocation && (
        <Routes>
          <Route element={<ModalLayout />}>
            <Route element={<CreateChannelContextLayout />}>
              <Route path="/editChannel/*" element={<EditChannel />} />
              <Route path="/topic" element={<ChannelTopic />} />
              <Route path="/age" element={<ChannelAge />} />
              <Route path="/certification" element={<ChanneCertification />} />

              <Route path="/history" element={<MyChannelHistory />} />
              <Route path="/success" element={<ChannelSuccess />} />
            </Route>
            {/* <Route element={<CreateChannelContextLayout />}>
              <Route path="/edit-channel" element={<ChannelTopic />} />
              <Route path="/edit-topic" element={<ChannelTopic />} />
              <Route path="/edit-age" element={<ChannelAge />} />
              <Route path="/edit-certification" element={<ChanneCertification />} />
            </Route> */}
          </Route>
        </Routes>
      )}
    </CreateChannelProvider>
  );
};

export const EditChannel = () => {
  // const context = useAuth();
  // const navigate = useNavigate();
  // const location = useLocation();

  // const { backgroundLocation } = useNavigationBar();
  // const oldLocation = backgroundLocation || location;
  // const newLocation = { ...oldLocation, pathname: oldLocation.pathname };

  return (
    <>
      <EditChannelProvider>
        <Routes>
          <Route element={<ModalLayout />}>
            <Route element={<EditChannelContextLayout />}>
              <Route path="/" element={<ChannelEditView />} />
              <Route path="/topic" element={<ChannelTopic isEdit={true} />} />
              <Route path="/age" element={<ChannelAge isEdit={true} />} />
              <Route path="/certification" element={<ChanneCertification isEdit={true} />} />
            </Route>
          </Route>
        </Routes>
        {/* )} */}
      </EditChannelProvider>
    </>
  );
};

export default Channel;
